// extracted by mini-css-extract-plugin
module.exports = {"information":"Information_information__3VN4e","informationInstruction":"Information_informationInstruction__1sUvk"};